<template>
    <v-content pa-0>
        <Header></Header>
        <loading :active.sync="isLoading" :is-full-page="true"></loading>
        <v-layout justify-center style="background-color: #006738; text-align: center" >
            <v-flex xs10 lg8 py-3 class="textHead" :class="{'textHead-mobile': $vuetify.breakpoint.smAndDown }">
                วิเคราะห์จุดเสี่ยง กทม.
            </v-flex>
        </v-layout>
        <!-- Layout -->
        <v-layout justify-center>
            <v-flex xs10 sm10 md8 lg8>
                <v-layout row justify-center >
                    <v-flex md4 pa-1>
                        <!-- Select Day -->
                        <v-layout style="text-align: center">
                            <v-flex class="textTopic pt-3 mb-3">
                                เลือกช่วงวัน
                            </v-flex>
                        </v-layout>
                        <v-layout justify-center>
                            <v-flex shrink>
                                <v-menu
                                        ref="menu"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                                outlined
                                                dense
                                                style="max-width: 120px; border-radius: 5px"
                                                placeholder="01/01/2016"
                                                v-on="on"
                                                v-model="start_date" :max="end_date"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="start_date" :max="end_date" no-title @input="menu = false"></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex shrink class="textTopic pt-3 mx-2">
                                ถึง
                            </v-flex>
                            <v-flex shrink>
                                <v-menu
                                        ref="menu"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                                outlined
                                                dense
                                                style="max-width: 120px; border-radius: 5px"
                                                :placeholder="date| moment('DD/MM/YYYY')"
                                                v-on="on"
                                                v-model="end_date" :min="start_date"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="end_date" :min="start_date" no-title @input="menu = false"></v-date-picker>
                                </v-menu>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex md4 pa-1>
                        <!-- Select time -->
                        <v-layout style="text-align: center">
                            <v-flex class="textTopic mb-3" :class="{'pt-3': $vuetify.breakpoint.smAndUp }">
                                เลือกช่วงเวลา
                            </v-flex>
                        </v-layout>
                        <v-layout justify-center >
                            <v-flex shrink>
                                <v-menu
                                        ref="menu"
                                        v-model="menu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                                outlined
                                                dense
                                                style="max-width: 120px; border-radius: 5px"
                                                v-model="start_time" :max="end_time"
                                                readonly
                                                v-on="on"
                                                placeholder="00:00"
                                        ></v-text-field>
                                    </template>
                                    <v-time-picker
                                            format="24hr"
                                            v-if="menu"
                                            v-model="start_time" :max="end_time"
                                            full-width
                                            color="#006738"
                                            header-color="#006738"
                                    ></v-time-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex shrink class="textTopic pt-3 mx-2">
                                ถึง
                            </v-flex>
                            <v-flex shrink>
                                <v-menu
                                        ref="menu"
                                        v-model="menu2"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                                outlined
                                                dense
                                                style="max-width: 120px; border-radius: 5px"
                                                v-model="end_time" :min="start_time"
                                                readonly
                                                v-on="on"
                                                placeholder="23:59"
                                        ></v-text-field>
                                    </template>
                                    <v-time-picker
                                            v-if="menu2"
                                            format="24hr"
                                            v-model="end_time" :min="start_time"
                                            full-width
                                            color="#006738"
                                            header-color="#006738"
                                    ></v-time-picker>
                                </v-menu>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <!-- How much Die -->
                    <v-flex md4 pa-1>
                        <!-- Select Die -->
                        <v-layout style="text-align: center">
                            <v-flex class="textTopic mb-3" :class="{'pt-3': $vuetify.breakpoint.smAndUp }">
                                จำนวนผู้เสียชีวิต
                            </v-flex>
                        </v-layout>
                        <v-layout justify-center>
                            <v-flex shrink>
                                <v-select
                                        outlined
                                        dense
                                        style="max-width: 120px; border-radius: 5px"
                                        menu-props="offsetY"
                                        :items="manydieA ? manydieA:manydie"
                                        v-model="start_die"
                                        @change="Selectmin"
                                ></v-select>
                            </v-flex>
                            <v-flex shrink class="textTopic pt-3 mx-2">
                                ถึง
                            </v-flex>
                            <v-flex shrink>
                                <v-select
                                        outlined
                                        dense
                                        style="max-width: 120px; border-radius: 5px"
                                        menu-props="offsetY"
                                        :items="manydieB ? manydieB:manydie"
                                        v-model="end_die"
                                        @change="Selectmax"
                                ></v-select>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <!-- Select Area -->
<!--                <v-layout justify-center mb-3>-->
<!--                    <v-flex :class="{'xs10': $vuetify.breakpoint.xs}">-->
<!--                        <div class="textTopic mb-2">จังหวัด</div>-->
<!--                        <v-select-->
<!--                                label="กรุงเทพมหานคร"-->
<!--                                menu-props="offsetY"-->
<!--                                :items="allRiskpoint.data"-->
<!--                                item-text="name_riskpoint"-->
<!--                                item-value="id"-->
<!--                                @change="onselect"-->
<!--                                outlined-->
<!--                                style="max-width: 270px"-->
<!--                                dense-->
<!--                        ></v-select>-->
<!--                    </v-flex>-->
<!--                </v-layout>-->
                <v-layout row style="text-align: center">
                    <v-flex md4 pa-1>
                        <v-layout style="text-align: center">
                            <v-flex class="textTopic mb-3">
                                เขต
                            </v-flex>
                        </v-layout>
                        <v-layout justify-center>
                            <v-flex shrink>
                                <v-select
                                        outlined
                                        dense
                                        style="width: 280px"
                                        menu-props="offsetY"
                                        :items="fieldbangkok"
                                        v-model="selectedDistrict"
                                        @change="setSelectedDistrict"
                                        placeholder="ดูทั้งหมด"
                                        :style="$vuetify.breakpoint.smAndUp ? {'width':'280px'}:{'width':'200px'}"
                                ></v-select>
                            </v-flex>
                        </v-layout>

                    </v-flex>
                    <v-flex md4 mt-11>
                        <v-btn
                                dark
                                style="background-color: #006738"
                                @click="ondatetime(start_date,end_date,start_time,end_time,start_die,end_die,selectedDistrict)"
                        >ค้นหา</v-btn>
                    </v-flex>
                    <v-flex md4></v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout justify-center>
            <v-flex xs12 sm10>
                <!-- Google Map -->
                <v-layout justify-center style="margin-bottom: 2%">
                    <v-flex :class="{'xs10': $vuetify.breakpoint.xs}" class="mb-5">
                        <GmapMap
                                :center="{lat:onlet, lng:onlng}"
                                :zoom="zoomsize"
                                map-type-id="terrain"
                                style="width: 100%;box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);"
                                :style="$vuetify.breakpoint.mdAndUp ? {'height':'800px'}:{'height':'400px'}"
                        >
                            <gmap-marker
                                    :key="index"
                                    v-for="(item,index) in allRiskpoint"

                                    :position="{lat:parseFloat(item.latitude_center), lng:parseFloat(item.longitude_center)}"
                                    :clickable="true"
                                    :draggable="false"
                                    @click="onTable(item.id,item.name_riskpoint,item.latitude_center,item.longitude_center)"
                            ></gmap-marker>
                        </GmapMap>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <TableRisk></TableRisk>
        <Footer></Footer>
    </v-content>
</template>


<script>
    import Header from "../components/Header"
    import Footer from "../components/Footer"
    import {mapState, mapActions,mapMutations} from 'vuex'
    import TableRisk from "../components/TableRisk"
    import Loading from "vue-loading-overlay";

    export default {
        name: "Riskpoint",
        components: {
            Header,
            Footer,
            TableRisk,
            Loading
        },
        data: () => ({
            isLoading: false,
            onlet: 13.785,
            onlng: 100.63,
            zoomsize: 13,
            time: ['00:00','01:00','02:00','03:00','04:00','05:00','06:00','07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00'],
            start_time: "",
            end_time: "",
            date: new Date().toISOString().substr(0, 10),
            start_date: "",
            end_date: "",
            menu: false,
            menu2: false,
            manydie: [],
            manydieA: "",
            manydieB: "",
            start_die: 2,
            end_die: "",
            district: "",
            alldata: "",
            fieldbangkok: ["ดูทั้งหมด","คลองสาน","คลองสามวา","คลองเตย","คันนายาว","จตุจักร","จอมทอง","ดอนเมือง","ดินแดง","ดุสิต","ตลิ่งชัน","ทวีวัฒนา","ทุ่งครุ","ธนบุรี","บางกอกน้อย","บางกอกใหญ่","บางกะปิ","บางขุนเทียน","บางคอแหลม","บางซื่อ","บางนา","บางบอน","บางพลัด","บางรัก","บางเขน","บางแค","บึงกุ่ม","ปทุมวัน","ประเวศ","ป้อมปราบศัตรูพ่าย","พญาไท","พระนคร","พระโขนง","ภาษีเจริญ","มีนบุรี","ยานนาวา","ราชเทวี","ราษฎร์บูรณะ","ลาดกระบัง","ลาดพร้าว","วังทองหลาง","วัฒนา","สวนหลวง","สะพานสูง","สัมพันธวงศ์","สาทร","สายไหม","หนองจอก","หนองแขม","หลักสี่","ห้วยขวาง"]
        }),
        async created() {
            if (!this.selectedDistrict){
                await this.onGetAllRiskpoint();
            }
            this.findMaxDies();

            this.onGetAllRiskpoint();
            // if (this.selectedDistrict) {
            //     this.district = this.selectedDistrict
            // }
        },
        computed: {
            ...mapState({
                allRiskpoint: state => state.riskpoint.allRiskpoint,
                allPatient: state => state.patient.allPatient,
                alldatachart: state => state.datachart.alldatachart,
                selectedDistrict: state => state.riskpoint.selectedDistrict
            }),
        },
        watch: {
            testday: function () {
              if (this.start_date && this.end_date){
                  let a = this.end_date
                  let b = this.start_date
                  console.log(a,b)
              }
            },
            accidentStartTime: function () {
                if (this.start_time && this.end_time) {
                    let a = this.start_time.substring(0,5)
                    let b = this.end_time.substring(0,5)
                    console.log(a,b)
                }
            },

            // accidentEndTime: function () {
            //     if (this.start && this.end) {
            //
            //         let a = parseInt(this.start.substring(0,2))
            //         let b = parseInt(this.end.substring(0,2))
            //         console.log(a,b)
            //         for (var i =0;i<10;i++) {
            //             let timedata = parseInt(this.allPatient.data[i]['accident_data'].substring(11,13))
            //             let timedatab = this.allPatient.data[1]['vehicle_type']
            //             let namedata = this.allPatient.data[0]['id']
            //             let namedata2 = this.allPatient.data[0]['latitude']
            //             console.log(timedata)
            //             console.log(timedatab)
            //             if (timedata >= a && timedata < b){
            //                 console.log(namedata)
            //             }else {
            //                 console.log(namedata2)
            //             }
            //         }
            //
            //
            //     }
            // }
        },
        methods: {
            ...mapActions('riskpoint', ['onGetAllRiskpoint','onGetRiskpointdatetime']),
            ...mapActions('patient', ['onGetPatient','onGetPatientdatetime']),
            ...mapActions('datachart', ['onGetDatachart']),
            ...mapMutations('riskpoint',['setSelectedDistrict','setAllRiskpoint']),
            onTable(id,location,centerlet,centerlng) {
                this.onGetPatient(id);
                this.$router.push({ name: 'Patient', params: {riskpoint : location,oncenterlet : centerlet , oncenterlng : centerlng } });
                // this.$router.push("/patient");

            },
            async ondatetime(start_date,end_date,start_time,end_time,start_die,end_die,district) {
                // this.setSelectedDistrict(this.selectedDistrict);
                this.onGetRiskpointdatetime({
                    start_date,
                    end_date,
                    start_time,
                    end_time,
                    start_die,
                    end_die,
                    district
                });
                this.onGetPatientdatetime({
                    start_date,
                    end_date,
                    start_time,
                    end_time,
                    start_die,
                    end_die,
                    district
                });
                this.zoomsize = 15;
                await this.allRiskpoint.filter(item => {
                    if (this.selectedDistrict == item.subdistrict) {
                        this.onlet = parseFloat(item.latitude_center)
                        this.onlng = parseFloat(item.longitude_center)
                        console.log(item.latitude_center)
                        console.log(item.longitude_center)
                    }
                });


            },
            Selectmin() {
                let b = this.manydie[this.manydie.length-1];
                this.manydieB = [];
                for (let i = 1;i <= b;i++) {
                    this.manydieB.push(i)
                }

            },
            Selectmax() {
                let b = this.end_die;
                this.manydieA = [];
                for (let i = 1;i <= b;i++) {
                    this.manydieA.push(i)
                }

            },
            findMaxDies(){
                let allDies = [];
                let len = Object.keys(this.allRiskpoint).length;
                console.log(len);
                for (const item of this.allRiskpoint) {
                    allDies.push(item.summary_riskpoint)
                }
                for (let i = 1;i <= Math.max(...allDies);i++) {
                    this.manydie.push(i)
                }
                this.end_die = this.manydie[this.manydie.length-1]
            },
            // onselect(district) {
            //     this.zoomsize = 15;
            //     this.allRiskpoint.filter(item => {
            //         if (this.district == item.subdistrict) {
            //             this.onlet = parseFloat(item.latitude_center)
            //             console.log(item.latitude_center)
            //             this.onlng = parseFloat(item.longitude_center)
            //             console.log(item.longitude_center)
            //         }
            //     });
            // },


        }
    }
</script>

<style scoped>


</style>
